export const HOME = "/";
export const LOGIN = "/login";
export const PRODUCTS = "/produtos";
export const MY_ACCOUNT = "/minha-conta";
export const HELP = "/ajuda";
export const NOT_FOUND = "/404";
